interface AudioPlayerAvailabilityParams {
  caseRecordId?: string | null;
  isLoadingAssets?: boolean;
  recordingAssetId?: string | null;
  organizationId?: string | null;
  programId?: string | null;
}

export const getAudioPlayerAvailability = ({
  caseRecordId,
  isLoadingAssets = false,
  recordingAssetId,
  organizationId,
  programId,
}: AudioPlayerAvailabilityParams) => {
  const hasCaseRecord = !!caseRecordId;
  const hasRecordingAsset = !!recordingAssetId;
  const hasContext = !!organizationId && !!programId;
  const isPendingAssets = hasCaseRecord && isLoadingAssets && !hasRecordingAsset;
  const isUnavailable = !hasCaseRecord || (!hasRecordingAsset && !isPendingAssets);
  const isPendingContext = !isUnavailable && !hasContext;
  const canLoadAudio = !isUnavailable && hasContext;

  return {
    canLoadAudio,
    hasCaseRecord,
    hasContext,
    hasRecordingAsset,
    isPendingAssets,
    isPendingContext,
    isUnavailable,
  };
};
